'use client';

import { AuthSessionContext } from '@/store/session/AuthSessionContext';
import {
  ClientAuthenticationSession,
  defaultSessionCookie,
} from '@/store/session/types';
import { useContext } from 'react';
import { publishEvent } from './publishEvent';

export const usePublishEvent = (initSession?: ClientAuthenticationSession) => {
  const store = useContext(AuthSessionContext);

  return (
    eventName: string,
    elementId: string,
    extraData?: Record<string, unknown>,
  ) =>
    publishEvent(
      initSession || store?.getState() || defaultSessionCookie,
      eventName,
      elementId,
      extraData,
    );
};
